<template>
    <v-row>
        <v-col cols="12" justify="center" align="center">
            <qrcode-vue :value="`https://paron-card.gr/#/Wallet?card=${$store.getters.getCard.card}&initials=${$store.getters.getInitials.initials}`" class="mb-5" :size="200" level="H" />
            <div 
                v-if="front" 
                :class="getFrontCardClass()"
                class="py-2 transition" 
                @click="rotation" 
                v-bind:style="{transform: `perspective(600px) rotateY(${deg}deg)`}"
            >
                <div v-show="isDimos()" class="ilioupoli-card-text"> 
                    <span v-if="teamId === 77">{{ 'ΚΑΡΤΑ ΔΗΜΟΤΗ' }}</span>
                </div>
                <div v-if="isDimos()" class="ilioupoli-card-number"> 
                    No. {{ $store.getters.getCard.card }}
                </div>
                <div v-if="!isDimos()" class="member-text"> 
                    {{ $store.getters.getParonMember.member.vipGroup ? $store.getters.getParonMember.member.vipGroup : 'Simple Member' }}
                </div>
                <div v-if="!isDimos()" class="paron-text">
                    PARON CARD
                </div>
                <v-img
                    v-if="!isDimos()"
                    max-width="140px"
                    height="auto"
                    src="@/assets/LOGOPARON 2023.svg"
                    class="paron-logo"
                />
                <div v-if="!isDimos()" class="paron-card-number ml-5">
                    Card No. {{ $store.getters.getCard.card }}
                </div>
            </div>
            <div 
                v-else
                :class="getBackCardClass()" 
                class="py-4 transition" 
                @click="rotation" 
                v-bind:style="{transform: `perspective(600px) rotateY(${deg}deg)`}"
            >
                <div v-if="isDimos()" class="ilioupoli-card-member">
                    <span style="color: #ad282d;">Name</span> {{ $store.getters.getFirstName.firstName + ' ' + $store.getters.getLastName.lastName }}
                    <div class="mt-2">VIP</div>
                </div>
                <div v-if="isDimos()" class="lokroi-member-since">
                    <span style="color: #ad282d;">Member Since</span> <span style="background-color: white;"> {{ getFormatedDate() }} </span> 
                </div>
                <div v-if="!isDimos()" class="paron-back-text ml-5"> 
                    Ον/μο: {{ $store.getters.getFirstName.firstName + ' ' + $store.getters.getLastName.lastName }}
                </div>
                <div v-if="!isDimos()" class="paron-back-text ml-5 mt-2">
                    Σύλλογος: {{ teamTitle || '-' }}
                </div>
                <v-img
                    v-if="!isDimos()"
                    max-width="130px"
                    height="auto"
                    src="@/assets/LOGOPARON 2023.svg"
                    class="paron-logo-back"
                />
                <v-img
                    v-if="teamId === 51"
                    max-width="70px"
                    height="auto"
                    src="@/assets/PSAK-LOGO.png"
                    style="position: absolute; right: 10px;"
                />
                <!-- <div :class="isDimos() ? 'paron-back-text ilioupoli-card-text-back ml-5' : 'paron-back-text ml-5'">
                    Ισχύει έως: {{ getFormatedDate() }}
                </div> -->
            </div>
        </v-col>
    </v-row>
</template>

<script>
    import QrcodeVue from 'qrcode.vue'
    // import restApi from "@/rest-api"
 
    export default {
        components: { QrcodeVue },
        data: () => ({
            deg: 0,
            front: true,
        }),
        computed: {
            // members without a team have team: null; reading team.id used to stop the whole card from drawing
            teamId() {
                const paronMember = this.$store.getters.getParonMember
                const team = paronMember && paronMember.member && paronMember.member.team
                return team ? team.id : null
            },
            teamTitle() {
                const paronMember = this.$store.getters.getParonMember
                const team = paronMember && paronMember.member && paronMember.member.team
                return team ? team.title : ''
            }
        },
        methods: {
            getFormatedDate() {
                let objectDate = new Date(this.$store.getters.getParonMember.member.createdAt)

                let day = objectDate.getDate()

                let month = objectDate.getMonth()

                let year = objectDate.getFullYear()

                return day + "/" + month + "/" + year
            },
            rotation() {
                this.deg += 360
                this.front = !this.front
            },
            isDimos() {
                return this.teamId === 87 || this.teamId === 77 || this.teamId === 83 || this.teamId === 84
            },
            getFrontCardClass() {
                if (this.teamId === 77) {
                    return 'paron-card-ilioupoli'
                } else if (this.teamId === 83) {
                    return 'paron-card-perama'
                } else if (this.teamId === 84) {
                    return 'paron-card-souli'
                } else if (this.teamId === 87) {
                    return 'paron-card-lokroi'
                } else {
                    return 'paron-card'
                }
            },
            getBackCardClass() {
                if (this.teamId === 77) {
                    return 'paron-card-back-ilioupoli'
                } else if (this.teamId === 83) {
                    return 'paron-card-back-perama'
                } else if (this.teamId === 84) {
                    return 'paron-card-back-souli'
                } else if (this.teamId === 87) {
                    return 'paron-card-back-lokroi'
                }else {
                    return 'paron-card-back'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    @media only screen and (min-width: 601px){
        .wallet{
            height: 100vh;
        }

        .card-number{
            position: absolute;
            top: 72%;
            right: 57%;
            font-size: 1.7rem;
        }

        .qr-code{
            position: absolute;
            right: 9%;
        }

        .paron-logo{
            margin-left: 50%;
        }

        .ilioupoli-card-text {
            font-weight: bold;
            font-size: 1.3rem;
            margin-top: 150px;
            margin-left: -200px;
        }

        .ilioupoli-card-text-back {
            font-weight: bold;
            font-size: 1rem;
            margin-top: 120px;
            margin-left: -220px;
        }

        .ilioupoli-card-number {
            font-weight: bold;
            font-size: 1rem;
            margin-top: -145px;
            margin-left: 320px;
        }

        .ilioupoli-card-member {
            font-weight: bold;
            font-size: 1.2rem;
            margin-top: 18px;
            margin-left: 0px;
        }

        .lokroi-member-since {
            font-size: 1rem;
            text-align: initial;
            margin-left: 13%;
            margin-top: 30%;
        }
    }


    @media only screen and (max-width: 600px){
        .ilioupoli-card-number {
            font-weight: bold;
            font-size: 0.7rem;
            margin-top: -85px;
            margin-left: 200px;
        }

        .ilioupoli-card-text {
            font-weight: bold;
            font-size: 1rem;
            margin-top: 140px;
            margin-left: -150px;
        }

        .ilioupoli-card-text-back {
            font-weight: bold;
            font-size: 0.7rem;
            margin-top: 170px;
            margin-left: -150px;
        }

        .wallet{
            min-height: 100vh;
        }

        .card-number{
            position: absolute;
            top: 71%;
            right: 51%;
            font-size: 1.5rem;
        }

        .qr-code{
            position: absolute;
            top: 10%;
            right: 9%;
            height: 100px;
        }

        .paron-logo{
            margin-left: 60%;
        }

        .ilioupoli-card-member {
            font-weight: bold;
            font-size: 0.9rem;
            position: absolute;
            top: 22%;
            right: 20%;
        }

        .lokroi-member-since {
            font-size: 1rem;
            text-align: initial;
            position: absolute;
            top: 222px;
            left: 10%;
        }
    }

    .transition {
        transition: transform .6s cubic-bezier(0.4, 0.0, 0.2, 1);
    }

    .paron-card{
        max-width: 460px;
        height: 280px;
        background-color: white;
        border: 1px solid black;
        border-radius: 20px;
        background-image: url('../assets/paron-card-waves.png');
        background-position: center;
        background-size: cover;
    }

    .paron-card-ilioupoli{
        max-width: 500px;
        height: 320px;
        background-color: white;
        background-image: url('../assets/paron_card_ilioupoli_front.png');
        background-position: center;
        background-size: contain;
    }

    .paron-card-perama{
        max-width: 500px;
        height: 320px;
        background-color: white;
        background-image: url('../assets/perama/paron_card_ΠΕΡΑΜΑ-01.png');
        background-position: center;
        background-size: contain;
    }

    .paron-card-souli{
        max-width: 500px;
        height: 320px;
        background-color: white;
        background-image: url('../assets/souli/paron_card_ΣΟΥΛΙ-01.png');
        background-position: center;
        background-size: contain;
    }

    .paron-card-lokroi{
        max-width: 500px;
        height: 320px;
        background-color: white;
        background-image: url('../assets/lokroi/paron-card-lokroi-1.jpg');
        background-position: center;
        background-size: contain;
    }

    .member-text{
        font-size: 1rem;
        margin-left: 50%;
    }

    .paron-text{
        font-weight: bold;
        font-size: 1rem;
        letter-spacing: 3px;
        margin-left: 50%;
    }

    .paron-card-number{
        font-size: 1.3rem;
        text-align: initial;
    }

    .paron-card-back{
        max-width: 460px;
        height: 280px;
        background-color: white;
        border: 1px solid black;
        border-radius: 20px;
        background-image: url('../assets/paron-back-waves.png');
        background-position: center;
        background-size: contain;
    }

    .paron-card-back-ilioupoli{
        max-width: 500px;
        height: 320px;
        background-color: white;
        background-image: url('../assets/paron_card_ilioupoli_back.png');
        background-position: center;
        background-size: contain;
    }

    .paron-card-back-perama{
        max-width: 500px;
        height: 320px;
        background-color: white;
        background-image: url('../assets/perama/paron_card_ΠΕΡΑΜΑ-02.png');
        background-position: center;
        background-size: contain;
    }

    .paron-card-back-souli{
        max-width: 500px;
        height: 320px;
        background-color: white;
        background-image: url('../assets/souli/paron_card_ΣΟΥΛΙ-02.png');
        background-position: center;
        background-size: contain;
    }

    .paron-card-back-lokroi{
        max-width: 500px;
        height: 320px;
        background-color: white;
        background-image: url('../assets/lokroi/paron-card-lokroi-2.jpg');
        background-position: center;
        background-size: contain;
    }

    .paron-back-text{
        font-size: 1rem;
        text-align: initial;
    }
</style>